// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"descriptionContainer__1Qe0g","descriptionText":"descriptionText__2CkgW","descriptionButton":"descriptionButton__2KGX-"};